exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "._2rzkgvgXOQ-TOXygVkIVYt .panel-title{font-size:14px}._2rzkgvgXOQ-TOXygVkIVYt .panel-title>a{cursor:pointer;display:block}._2rzkgvgXOQ-TOXygVkIVYt .panel-body{padding:10px}._2rzkgvgXOQ-TOXygVkIVYt ul{padding-left:0}", ""]);

// exports
exports.locals = {
	"helpPanel": "_2rzkgvgXOQ-TOXygVkIVYt"
};